import { put, call, take, fork } from 'redux-saga/effects'
import { courseCardLinkPatchService } from '../../api/card'
import { courseCardLinkPatchSuccess } from '../../reducers/card/action'
import { COURSE_CARD_LINK_PATCH } from '../../reducers/card/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* courseCardLinkPatchFlow(payload) {
  try {
    const { content, cardId, callback } = payload
    yield call(courseCardLinkPatchService, content)
    yield put(courseCardLinkPatchSuccess(content, cardId))
    yield put(operationSuccess())

    callback()
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* courseCardLinkPatchWatcher() {
  while (true) {
    const action = yield take(COURSE_CARD_LINK_PATCH)
    const { payload } = action

    yield fork(generalSaga, courseCardLinkPatchFlow, payload)
  }
}
